<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
      <router-link class="breadcrumb-link" to="/action-pages">Action Pages</router-link> &gt;
      <a href="#" class="breadcrumb-link" v-if="activeTab=='mobile'" @click.prevent="activateTab('mobile')">Mobile View</a>
      <a href="#" class="breadcrumb-link" v-if="activeTab=='desktop'" @click.prevent="activateTab('desktop')">Desktop View</a>
    </div>
    <h3>Campaign Action Pages <span>- {{ activeTab }} view</span></h3>

    <div class="ws-large-tab-menu">
        <a href="#" :class="activeTab=='mobile'?'active':''" @click.prevent="activateTab('mobile')">Mobile View</a>
        <a href="#" :class="activeTab=='desktop'?'active':''" @click.prevent="activateTab('desktop')">Desktop View</a>
    </div>

    <div v-if="actionPage" id="action-pages-form" class="large-form" :class="'tab-'+activeTab" >
        <div class="form-left">
            <h4><b><span v-html="activeTab=='mobile'?'Mobile':'Desktop'"></span> Action Pages Settings </b></h4>
            <div class="small-note" style="max-width: 500px"><b>Action Pages</b> are the front pages of your campaigns. This are the pages that your customers see to <i>claim gifts</i>, <i>leave a review</i> or <i>fill a survey</i>. They are also used to claim gift invitations from <i>Marketplace</i>.</div>

            <div class="form-line action-images">
                <div class="form-line-fields">
                    <div id="form-field-hero" class="form-field form-field-half" >
                        <label>Mobile Hero Image</label>
                        <div class="form-field form-field-checkbox">
                          <input type="checkbox" v-model="actionPage[activeTab].displayHero" @change="updateSettings">
                          <span class="checkbox-label">Display Hero Image</span>
                        </div>
                        <div v-if="actionPage[activeTab].displayHero">
                            <div v-if="team.hero_url"><img :src="team.hero_url" alt="Action Page Mobile Hero Image" class="team-hero-image"></div>
                            <div @click="onUploadBtnClick('hero_url')" class="ws-button ws-button-secondary">{{ team.hero_url ? 'Update' : 'Upload'}} Hero Image</div>
                            <input ref="heroUploadInput" accept="image/*" style="display: none" type="file" @change="uploadImage('hero_url',$event)">
                            <div class="upload-note">1040px x 306px works best.</div>
                        </div>
                    </div>

                    <div id="form-field-hero" class="form-field form-field-half">
                        <label>Action Page Team Logo</label>
                        <div class="form-field form-field-checkbox">
                          <input type="checkbox" v-model="actionPage[activeTab].displayLogo" @change="updateSettings">
                          <span class="checkbox-label">Display Team Logo</span>
                        </div>
                        <div class="form-field form-field-checkbox" v-if="!actionPage[activeTab].displayLogo">
                          <input type="checkbox" v-model="actionPage[activeTab].displayTeamName" @change="updateSettings">
                          <span class="checkbox-label">Display Team Name Instead</span>
                        </div>
                        <div v-if="actionPage[activeTab].displayLogo">
                            <div v-if="team.action_logo_url"><img :src="team.action_logo_url" alt="Action Page Team Logo" class="team-hero-image"></div>
                            <div @click="onUploadBtnClick('action_logo_url')" class="ws-button ws-button-secondary">{{ team.action_logo ? 'Update' : 'Upload'}} Team Logo</div>
                            <input ref="logoUploadInput" accept="image/*" style="display: none" type="file" @change="uploadImage('action_logo_url',$event)">
                            <div class="upload-note">100px height & transparent background.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-line">
                <div class="form-line-fields">
                    <label>Campaign Gift Options</label>
                    <div class="form-field form-field-checkbox">
                      <input type="checkbox" v-model="actionPage[activeTab].displayCampaignName" @change="updateSettings">
                      <span class="checkbox-label">Display Campaign Name</span>
                    </div>
                    <div class="form-field form-field-checkbox">
                      <input type="checkbox" v-model="actionPage[activeTab].displayCampaignDescription" @change="updateSettings">
                      <span class="checkbox-label">Display Campaign Description</span>
                    </div>
                    <div class="form-field form-field-checkbox">
                      <input type="checkbox" v-model="actionPage[activeTab].displayGiftNameMultiple" @change="updateSettings">
                      <span class="checkbox-label">Display Gift Names (Multiple Options Campaigns)</span>
                    </div>
                </div>
            </div>

            <h4>Theme & Colour Scheme</h4>
            <div class="form-line">
                <div class="form-line-fields">
                    <div class="form-field form-field-half">
                        <label for="name">Page Text</label>
                        <input v-model="actionPage[activeTab].textColour" type="color" required="required" @change="updateSettings" />
                    </div>
                    <div class="form-field form-field-half">
                        <label for="name">Page Background</label>
                        <input v-model="actionPage[activeTab].backgroundColour" type="color" required="required" @change="updateSettings"  />
                    </div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-line-fields">
                    <div class="form-field form-field-half">
                        <label for="name">Action Button Text</label>
                        <input v-model="actionPage[activeTab].buttonColour" type="color" required="required" @change="updateSettings"  />
                    </div>
                    <div class="form-field form-field-half">
                        <label for="name">Action Button Background</label>
                        <input v-model="actionPage[activeTab].buttonBackground" type="color" required="required" @change="updateSettings"  />
                    </div>
                </div>
            </div>

            <div class="form-line">
                <div class="form-line-fields">
                    <label>Action Button Options</label>
                    <div class="form-field form-field-checkbox">
                      <input type="checkbox" v-model="actionPage[activeTab].buttonRoundedCorners" @change="updateSettings">
                      <span class="checkbox-label">Rounded Corners</span>
                    </div>
                    <div class="form-field form-field-checkbox">
                      <input type="checkbox" v-model="actionPage[activeTab].buttonShadow" @change="updateSettings">
                      <span class="checkbox-label">Button Shadow</span>
                    </div>
                </div>
            </div>

            <h4>Texts & Labels</h4>
            <div class="form-line">
                <div class="form-line-fields">
                    <div class="form-field form-field-half">
                        <label for="name">Single Gift Claim Button Text</label>
                        <input v-model="actionPage[activeTab].buttonTextSingle" type="input" required="required" maxlength="25"  />
                    </div>
                    <div class="form-field form-field-half">
                        <label for="name">Multi Gift Claim Button Text</label>
                        <input v-model="actionPage[activeTab].buttonTextMultiple" type="input" required="required" maxlength="25"  />
                    </div>
                </div>
            </div>

            <div class="form-line">
                <div class="form-line-fields">
                    <div id="form-field-name" class="form-field">
                        <label for="name">Marketplace Page Title</label>
                        <input v-model="actionPage[activeTab].marketplaceTitle" type="text" name="name" required="required" />
                    </div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-line-fields">
                    <div id="form-field-name" class="form-field">
                        <label for="name">Marketplace Page Description</label>
                        <input v-model="actionPage[activeTab].marketplaceDescription" type="text" name="name" required="required" />
                    </div>
                </div>
            </div>

            <div @click="updateSettings('button')" class="ws-button ws-button-primary">Save Changes</div>
            <div @click="resetSettings" class="ws-button ws-button-negative">Reset To Default</div>
        </div>
        <div class="form-right">
            <h4><b>Action Pages Preview </b> - <span v-html="activeTab=='mobile'?'Mobile':'Desktop'"></span></h4>
            <div class="action-page-preview" :class="activeTab">
                <iframe :src="team.preview_url" :key="iframeUpdate"></iframe>
            </div>
            <a class="action-page-preview-link" :href="team.preview_url" target="_blank">Display Preview In New Tab</a>
        </div>
      </div>
</div>
</template>

<script>
export default {
    name: "ActionPages",
    data() {
        return {
            activeTab: 'mobile',
            actionPage: null,
            iframeUpdate: false,
        }
    },
    methods: {
        async fetchData() {
            this.actionPage = this.team.action_page;
        },
        activateTab(tab) {
            this.activeTab = tab;
        },
        async uploadImage(field,event) {
            if (!this.demoCheck()) return;
            
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            formData.append("type", field);
            await this.dispatchWaitAndNotify('uploadTeamImage', formData, false, true);
            this.updateSettings();
        },
        onUploadBtnClick(what) {
            if (!this.demoCheck()) return;
            
            if (what=='action_logo_url') this.$refs.logoUploadInput.click();
            if (what=='hero_url') this.$refs.heroUploadInput.click();
        },
        async updateSettings(source = 'dynamic') {
            if (source == 'button' && !this.demoCheck()) return;
            if (this.demo.isDemo) return;
            
            var updateTeam = {
                'team_id': this.team.id,
                'action_page': this.actionPage
            };
            await this.dispatchWaitAndNotify('updateTeam', updateTeam, false, true);
            this.iframeUpdate = !this.iframeUpdate;
        },
        async resetSettings() {
            if (!this.demoCheck()) return;
            
            var updateTeam = {
                'team_id': this.team.id,
                'action_page': {},
            };
            await this.dispatchWaitAndNotify('updateTeam', updateTeam, false, true);
            this.iframeUpdate = !this.iframeUpdate;
        },
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        demo() {
            return this.$store.state.demo;
        },
        team() {
            return this.$store.state.team.detail;
        },
        teamCopy() {
            return this.$store.state.team.detailCopy;
        },
        user() {
            return this.$store.state.currentUser;
        },
        emailCategories() {
            return this.$store.state.emailCategories;
        },
        modals() {
            return this.$store.state.modals;
        },
        stripePaymentMethods() {
            return this.$store.state.transaction.stripePaymentMethods;
        }
    },
    watch: {
		'team.action_page': {
			handler () {
				this.actionPage = this.team.action_page;
			},
			deep: true,
		}
	}
}
</script>
